module.exports = __webpack_public_path__ + "static/media/titel.ee3a3b63.png";